import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import { API } from "API"
import * as Alert from "alertService"
import ConfigHost from "ConfigHost"

// core components

//Image
import defaultImage from "assets/img/image_placeholder_file_long.jpg"

class FileConfigUploadFileLeadCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagePreview: defaultImage,
      file: null,
      fileName: null,
      filePath: null,
      lockFileType: this.props.lockFileType
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentWillUpdate(pre, curr) {
    if (this.state.filePath !== pre.FilePath) {
      this.setState({
        filePath: pre.FilePath,
      });
    }
  }
  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        fileName: file.name,
        file: file,
      }, () => {
        this.handleUploadFile()
      });
    };
    if (file)
      reader.readAsDataURL(file);
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleUploadFile = () => {
    Alert.Loading(true)
    this.UploadFile()
  }
  UploadFile = () => {
    API("POST", "api/uploadFileLeadCustomer", { file: this.state.file }, ({ datas }) => {
      this.props.CallbackUploadedUrl(datas.fileName, this.state.file.name)
    }, null, true)
  }

  render() {
    return (
      <div >
        <input type="file" onChange={this.handleImageChange} ref="fileInput" hidden accept={(this.state.lockFileType) ? this.state.lockFileType : undefined} />
        <div className="img-fw can-click">
          <center>
            <span className="img-fw-txt">{this.state.filePath ? "ชื่อไฟล์ที่อัพโหลด คือ " + this.state.fileName + " , ลิ้งค์ที่อยู่ไฟล์ที่อัพโหลดแล้ว คือ " + this.state.filePath : "ยังไม่มีการเลือกอัพไฟล์"}</span>
          </center>
          <img src={
            this.state.imagePreview
          } alt="banner"
            onClick={() => this.handleClick()}
          />
        </div>
      </div >
    );
  }
}

FileConfigUploadFileLeadCustomer.propTypes = {
  FilePath: PropTypes.string,
  CallbackUploadedUrl: PropTypes.func,
};

export default FileConfigUploadFileLeadCustomer;
